module.exports = __webpack_public_path__ + "img/stu_avatar_8.fe687363.jpg";